var _g, _path, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_665_522)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.5 10C159.795 10 203 53.2046 203 106.5C203 159.795 159.795 203 106.5 203C53.2046 203 10 159.795 10 106.5C10 53.2046 53.2046 10 106.5 10ZM106.5 11.4836C158.976 11.4836 201.516 54.024 201.516 106.5C201.516 158.976 158.976 201.516 106.5 201.516C54.024 201.516 11.4836 158.976 11.4836 106.5C11.4836 54.024 54.024 11.4836 106.5 11.4836Z",
    fill: "#86D300"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.516 106.5C201.516 54.0238 158.976 11.4834 106.5 11.4834C54.0238 11.4834 11.4834 54.0238 11.4834 106.5C11.4834 158.976 54.0238 201.516 106.5 201.516C158.976 201.516 201.516 158.976 201.516 106.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.499 14.6196C157.243 14.6196 198.38 55.756 198.38 106.5C198.38 157.244 157.243 198.38 106.499 198.38C55.7556 198.38 14.6191 157.244 14.6191 106.5C14.6191 55.756 55.7556 14.6196 106.499 14.6196Z",
    fill: "#86D300"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_665_522)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.824 63.7847C150.776 64.5151 148.699 67.5818 146.962 69.5155L129.101 89.4231C121.293 98.4537 113.049 106.976 105.234 116.005C98.3605 123.946 98.8682 122.219 92.1265 113.612C88.0028 108.348 84.7652 102.313 79.2144 101.072C71.4038 99.3249 64.3335 105.843 66.5169 112.826C67.2475 115.163 70.123 118.463 71.5865 120.322C73.5261 122.785 75.2701 125.069 77.0992 127.44C79.1239 130.064 91.6461 146.814 93.7392 148.204C96.9859 150.361 101.373 149.472 103.489 147.196C105.366 145.176 107.255 142.424 108.914 140.24L125.441 118.886C132.884 109.438 139.958 100.025 147.403 90.5793C151.177 85.7919 154.776 81.0849 158.314 76.4935C159.912 74.4205 162.924 71.7384 162.027 68.0992C161.273 65.0452 157.764 62.8406 153.824 63.7847Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_665_522",
    x: 0,
    y: 0,
    width: 213,
    height: 213,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_665_522"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_665_522",
    x: 62.1152,
    y: 59.564,
    width: 104.075,
    height: 93.8726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_665_522"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_665_522",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.3236320fc7b60ed6c4547e3b990d401d.svg";
export { ForwardRef as ReactComponent };